export enum ZoomLevel {
  XXXXS = 1 / 16,
  XXXS = 1 / 9,
  XXS = 1 / 6,
  XS = 1 / 4,
  S = 1 / 2,
  M = 1,
  L = 2,
  XL = 4,
  XXL = 6,
  XXXL = 12
}
